// Generated by purs version 0.15.0
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Restaumatic_Menu_V2_MenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic_Menu_V2_Parametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic_Menu_V2_Types_ParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
var Constant = /* #__PURE__ */ (function () {
    function Constant(value0) {
        this.value0 = value0;
    };
    Constant.create = function (value0) {
        return new Constant(value0);
    };
    return Constant;
})();
var Range = /* #__PURE__ */ (function () {
    function Range(value0) {
        this.value0 = value0;
    };
    Range.create = function (value0) {
        return new Range(value0);
    };
    return Range;
})();
var semigroupPriceView = {
    append: function (v) {
        return function (v1) {
            if (v instanceof Constant && v1 instanceof Constant) {
                return new Constant({
                    value: Data_Numeric.add(Data_Money_Rounded.additiveMoney)(v.value0.value)(v1.value0.value)
                });
            };
            if (v instanceof Range && v1 instanceof Constant) {
                return new Range({
                    from: Data_Numeric.add(Data_Money_Rounded.additiveMoney)(v.value0.from)(v1.value0.value),
                    to: Data_Numeric.add(Data_Money_Rounded.additiveMoney)(v.value0.to)(v1.value0.value)
                });
            };
            if (v instanceof Range && v1 instanceof Range) {
                return new Range({
                    from: Data_Numeric.add(Data_Money_Rounded.additiveMoney)(v.value0.from)(v1.value0.from),
                    to: Data_Numeric.add(Data_Money_Rounded.additiveMoney)(v.value0.to)(v1.value0.to)
                });
            };
            if (v instanceof Constant && v1 instanceof Range) {
                return new Range({
                    from: Data_Numeric.add(Data_Money_Rounded.additiveMoney)(v.value0.value)(v1.value0.from),
                    to: Data_Numeric.add(Data_Money_Rounded.additiveMoney)(v.value0.value)(v1.value0.to)
                });
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.PriceView (line 36, column 1 - line 40, column 102): " + [ v.constructor.name, v1.constructor.name ]);
        };
    }
};
var priceView = function (price) {
    return function (parameterValues) {
        var v = Restaumatic_Menu_V2_Parametric.evaluateParametric(price)(parameterValues);
        if (v instanceof Data_Either.Left && v.value0 instanceof Restaumatic_Menu_V2_Parametric.MissingValue) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Data_Either.Right) {
            return new Data_Maybe.Just(new Constant({
                value: v.value0
            }));
        };
        if (v instanceof Data_Either.Left && v.value0 instanceof Restaumatic_Menu_V2_Parametric.MissingParameters) {
            var prices = Data_Map_Internal.values(Data_Newtype.unwrap()(v.value0.value1.values));
            var $36 = {
                min: Data_Foldable.minimum(Data_Money_Rounded.ordMoney)(Data_List_Types.foldableList)(prices),
                max: Data_Foldable.maximum(Data_Money_Rounded.ordMoney)(Data_List_Types.foldableList)(prices)
            };
            if ($36.min instanceof Data_Maybe.Just && ($36.max instanceof Data_Maybe.Just && Data_Eq.eq(Data_Money_Rounded.eqMoney)($36.min.value0)($36.max.value0))) {
                return new Data_Maybe.Just(new Constant({
                    value: $36.min.value0
                }));
            };
            if ($36.min instanceof Data_Maybe.Just && $36.max instanceof Data_Maybe.Just) {
                return new Data_Maybe.Just(new Range({
                    from: $36.min.value0,
                    to: $36.max.value0
                }));
            };
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.PriceView (line 25, column 3 - line 34, column 42): " + [ v.constructor.name ]);
    };
};
var productPriceView = function (_catalogue) {
    return function (product) {
        return function (parameterValues) {
            var $49 = Restaumatic_Menu_V2_Parametric.isPossible(Restaumatic_Menu_V2_Parametric.isParametricPossibleBoole)((Data_Newtype.unwrap()(product)).variants)(parameterValues);
            if ($49) {
                return priceView((Data_Newtype.unwrap()(product)).price)(parameterValues);
            };
            return Data_Maybe.Nothing.value;
        };
    };
};
var monoidPriceView = /* #__PURE__ */ (function () {
    return {
        mempty: new Constant({
            value: Data_Numeric.zero(Data_Money_Rounded.additiveMoney)
        }),
        Semigroup0: function () {
            return semigroupPriceView;
        }
    };
})();
var mergePriceView = function (v) {
    return function (v1) {
        if (v instanceof Constant && (v1 instanceof Constant && Data_Eq.eq(Data_Money_Rounded.eqMoney)(v.value0.value)(v1.value0.value))) {
            return new Constant({
                value: v.value0.value
            });
        };
        if (v instanceof Constant && v1 instanceof Constant) {
            return new Range({
                from: Data_Ord.min(Data_Money_Rounded.ordMoney)(v.value0.value)(v1.value0.value),
                to: Data_Ord.max(Data_Money_Rounded.ordMoney)(v.value0.value)(v1.value0.value)
            });
        };
        if (v instanceof Range && v1 instanceof Constant) {
            return new Range({
                from: Data_Ord.min(Data_Money_Rounded.ordMoney)(v.value0.from)(v1.value0.value),
                to: Data_Ord.max(Data_Money_Rounded.ordMoney)(v.value0.to)(v1.value0.value)
            });
        };
        if (v instanceof Range && v1 instanceof Range) {
            return new Range({
                from: Data_Ord.min(Data_Money_Rounded.ordMoney)(v.value0.from)(v1.value0.from),
                to: Data_Ord.max(Data_Money_Rounded.ordMoney)(v.value0.to)(v1.value0.to)
            });
        };
        if (v instanceof Constant && v1 instanceof Range) {
            return new Range({
                from: Data_Ord.min(Data_Money_Rounded.ordMoney)(v.value0.value)(v1.value0.from),
                to: Data_Ord.max(Data_Money_Rounded.ordMoney)(v.value0.value)(v1.value0.to)
            });
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.PriceView (line 45, column 1 - line 45, column 54): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var genericPriceView = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Constant(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new Range(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.PriceView (line 19, column 1 - line 19, column 56): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Constant) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Range) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.PriceView (line 19, column 1 - line 19, column 56): " + [ x.constructor.name ]);
    }
};
var showPriceView = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPriceView)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "value";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Money_Rounded.showMoney))))({
        reflectSymbol: function () {
            return "Constant";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "from";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "to";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Money_Rounded.showMoney))(Data_Money_Rounded.showMoney))))({
        reflectSymbol: function () {
            return "Range";
        }
    })))
};
var display = function (v) {
    if (v instanceof Constant) {
        return Data_Show.show(Data_Money_Rounded.showMoney)(v.value0.value);
    };
    if (v instanceof Range) {
        return Data_Show.show(Data_Money_Rounded.showMoney)(v.value0.from) + (" \u2013 " + Data_Show.show(Data_Money_Rounded.showMoney)(v.value0.to));
    };
    throw new Error("Failed pattern match at Restaumatic.Menu.V2.PriceView (line 78, column 3 - line 82, column 36): " + [ v.constructor.name ]);
};
var comboPriceView = function (catalogue) {
    return function (combo) {
        return function (paramValues) {
            var mergeMbPriceView = function (v) {
                return function (v1) {
                    if (v instanceof Data_Maybe.Just && v1 instanceof Data_Maybe.Just) {
                        return new Data_Maybe.Just(mergePriceView(v.value0)(v1.value0));
                    };
                    if (v instanceof Data_Maybe.Just && v1 instanceof Data_Maybe.Nothing) {
                        return new Data_Maybe.Just(v.value0);
                    };
                    if (v instanceof Data_Maybe.Nothing && v1 instanceof Data_Maybe.Just) {
                        return new Data_Maybe.Just(v1.value0);
                    };
                    if (v instanceof Data_Maybe.Nothing && v1 instanceof Data_Maybe.Nothing) {
                        return Data_Maybe.Nothing.value;
                    };
                    throw new Error("Failed pattern match at Restaumatic.Menu.V2.PriceView (line 56, column 3 - line 56, column 76): " + [ v.constructor.name, v1.constructor.name ]);
                };
            };
            var choicePriceView = function (choice) {
                return Control_Bind.bind(Data_Maybe.bindMaybe)(Restaumatic_Menu_V2_MenuCatalogue.lookupProduct(catalogue)((Data_Newtype.unwrap()(choice)).product))(function (product) {
                    var productPrice = Data_Maybe.fromMaybe((Data_Newtype.unwrap()(product)).price)((Data_Newtype.unwrap()(choice)).priceOverride);
                    return priceView(productPrice)(Data_Semigroup.append(Data_Map_Internal.semigroupMap(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))(paramValues)(Restaumatic_Menu_V2_Parametric.fromCustomParameterValues(Data_Newtype.unwrap()((Data_Newtype.unwrap()(choice)).customParameterValues))));
                });
            };
            var elementPriceView = function (element) {
                return Data_Maybe.fromMaybe(Data_Monoid.mempty(monoidPriceView))(Data_Foldable.foldr(Data_Foldable.foldableArray)(mergeMbPriceView)(Data_Maybe.Nothing.value)(Data_Functor.map(Data_Functor.functorArray)(choicePriceView)(Data_Map_Ordered.values((Data_Newtype.unwrap()(element)).choices))));
            };
            return Data_Foldable.fold(Data_Foldable.foldableArray)(monoidPriceView)(Data_Functor.map(Data_Functor.functorArray)(elementPriceView)(Data_Map_Ordered.values((Data_Newtype.unwrap()(combo)).elements)));
        };
    };
};
export {
    Constant,
    Range,
    priceView,
    mergePriceView,
    comboPriceView,
    productPriceView,
    display,
    genericPriceView,
    showPriceView,
    semigroupPriceView,
    monoidPriceView
};
//# sourceMappingURL=index.js.map
